import React from 'react';
import Chart from 'react-apexcharts';

const BillHistoryChart = ({ chartData }) => {
    if (!chartData || !chartData.labels || chartData.labels.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
                No historical data available.
            </div>
        );
    }

    const { labels, bill_graph, units_graph } = chartData;

    // Combine historical and forecast data
    const billSeriesData = [...(bill_graph?.historical_data || [])];
    if (bill_graph?.forecast_value !== undefined && bill_graph?.forecast_value !== null) {
        // Ensure the arrays are the same length as labels
        while (billSeriesData.length < labels.length - 1) {
            billSeriesData.push(null);
        }
        billSeriesData.push(bill_graph.forecast_value);
    }

    const unitsSeriesData = [...(units_graph?.historical_data || [])];
    if (units_graph?.forecast_value !== undefined && units_graph?.forecast_value !== null) {
        while (unitsSeriesData.length < labels.length - 1) {
            unitsSeriesData.push(null);
        }
        unitsSeriesData.push(units_graph.forecast_value);
    }

    const series = [
        {
            name: 'Bill (Rs.)',
            type: 'bar',
            data: billSeriesData
        },
        {
            name: 'Units',
            type: 'bar',
            data: unitsSeriesData
        }
    ];

    const options = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: true
            },
            zoom: {
                enabled: false
            }
        },
        colors: ['#002f46', '#009f8d'], // Dark Navy for Bill, Enfo Teal for Units
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: labels,
            labels: {
                style: {
                    fontSize: '12px',
                    colors: '#64748b'
                }
            }
        },
        yaxis: [
            {
                title: {
                    text: 'Bill (Rs.)',
                    style: {
                        color: '#64748b'
                    }
                },
                labels: {
                    style: {
                        colors: '#64748b'
                    },
                    formatter: (value) => {
                        if (value >= 1000) return (value / 1000).toFixed(0) + 'k';
                        return value.toFixed(0);
                    }
                }
            },
            {
                opposite: true,
                title: {
                    text: 'Units',
                    style: {
                        color: '#64748b'
                    }
                },
                labels: {
                    style: {
                        colors: '#64748b'
                    },
                    formatter: (value) => {
                        if (value >= 1000) return (value / 1000).toFixed(0) + 'k';
                        return value.toFixed(0);
                    }
                }
            }
        ],
        fill: {
            opacity: 1
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (y) {
                    if (typeof y !== "undefined") {
                        return y.toLocaleString();
                    }
                    return y;
                }
            }
        },
        legend: {
            position: 'bottom',
            markers: {
                radius: 12,
            }
        }
    };

    return (
        <div style={{ background: '#fff', borderRadius: 16, padding: 20, boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ margin: 0, fontSize: 18, color: '#0f172a' }}>Bill History</h3>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button style={styles.tabButtonActive}>Bill/Units</button>
                </div>
            </div>
            <Chart options={options} series={series} type="bar" height={350} />
        </div>
    );
};

const styles = {
    tabButtonActive: {
        padding: '6px 12px',
        backgroundColor: '#009f8d', // Enfo Teal
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px'
    },
    tabButtonInactive: {
        padding: '6px 12px',
        backgroundColor: 'transparent',
        color: '#002f46', // Dark Navy
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px'
    }
}

export default BillHistoryChart;
